<template>
    <div> 
        <v-dialog 
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-subtitle>
                    {{ $t("JOBCARD_EXT_MAINT_SUBTITLE") }}
                </v-card-subtitle>
                <v-card-text>
                    <div v-if="loading.data" class="text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        v-else
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :readonly="!!form.external_workshop_id"
                            @blur="!form.external_workshop_id ? form.external_workshop = null : null"
                            :clearable="true"
                            :append-icon="form.external_workshop_id ? '' : 'mdi-magnify'"
                            @click:clear="form.external_workshop_id = null"
                            :label="$t('JOBCARD_EXT_MAINT_EXT_WORSKHOP')"
                            @keypress.enter="openExternalMaintenanceSearchDialog"
                            v-model="form.external_workshop"
                            :rules="rules.external_workshop">
                        </v-text-field>
                        <v-text-field
                            :label="$t('JOBCARD_EXT_MAINT_DESC')"
                            v-model="form.description"
                            :rules="rules.description">
                        </v-text-field>
                        <v-text-field
                            :label="$t('JOBCARD_EXT_MAINT_QTY')"
                            v-model="form.quantity"
                            :rules="rules.quantity">
                        </v-text-field>
                        <v-text-field
                            :label="$t('JOBCARD_EXT_MAINT_PRICE')"
                            v-model="form.price"
                            :rules="rules.price">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="submit"
                        text
                        :disabled="!valid || loading.data || loading.submit"
                        :loading="loading.submit">
                        {{ $t("BTN_SAVE") }}
                    </v-btn>
                    <v-btn
                        @click="close"
                        text>
                        {{ $t("BTN_CANCEL") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ExternalWorkshopDialog 
            ref="externalWorkshopDialog"
            @record="selectAddedExternalWorkshop"/>
        <AlertDialog
            ref="alertDialog"/>
        <ExternalMaintenanceSearchDialog
            @submit="fillFeildData"
            ref="externalMaintenanceSearchDialog"/>
    </div>
</template>

<script>
import ExternalWorkshopDialog from "../components/ExternalWorkshopDialog";
import ExternalMaintenanceSearchDialog from '@/components/ExternalMaintenanceSearchDialog';
import AlertDialog from "../components/AlertDialog"
import { mapState, mapActions } from 'vuex';
export default {
    name: "jobcardExternalMaintenanceDialog",
    components: {
        ExternalWorkshopDialog,
        AlertDialog,
        ExternalMaintenanceSearchDialog
    },
    data() {
        return {
            display: false,
            editMode: false,
            valid:false,
            form: {
                id: null,
                jobcard_id: null,
                external_workshop_id: null,
                external_workshop: null,
                description: null,
                quantity: null,
                price: null
            },
            rules: {
                external_workshop: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                description: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ],
                quantity: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG"),
                    v => !isNaN(v) || this.$t("RULES_NUMERIC_MSG")
                ],
                price: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG"),
                    v => !isNaN(v) || this.$t("RULES_NUMERIC_MSG")
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed: {
        ...mapState("jobcardExternalMaintenance", ["jobcardExternalMaintenance"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"]),
        title() {
            if(!this.editMode) return this.$t("JOBCARD_EXT_MAINT_NEW_TITLE");
            else return this.$t("JOBCARD_EXT_MAINT_EDIT_TITLE");
        }
    },
    methods: {
        ...mapActions("jobcardExternalMaintenance", ["fetchJobcardExternalMaintenances", "fetchJobcardExternalMaintenance", "storeJobcardExternalMaintenance", "updateJobcardExternalMaintenance"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            this.form.jobcard_id = params.jobcard_id;
            if(this.editMode) {
                await this.fetchJobcardExternalMaintenance(params.id);
                this.form = this.jobcardExternalMaintenance;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.form.external_workshop_id = null;
            this.form.external_workshop = null;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        fillFeildData(params) {
            this.form.external_workshop_id = params.id;
            this.form.external_workshop = params.name;
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeJobcardExternalMaintenance(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardExternalMaintenances(this.form.jobcard_id);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else {
                this.updateJobcardExternalMaintenance(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardExternalMaintenances(this.form.jobcard_id);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            }
        },
        openExternalMaintenanceSearchDialog() {
            this.$refs.externalMaintenanceSearchDialog.open(this.form.external_workshop);
        },
        openExternalWorkshopDialog(params) {
            this.$refs.externalWorkshopDialog.open(params);
        },
        selectAddedExternalWorkshop(params) {
            this.form.external_workshop_id = params.id;
        }
    }
}
</script>